import LegalPage from "@/components/LegalPage";

export function TermsPage() {
  return <LegalPage titleKey="terms.title" contentKey="terms.content" />;
}